import { useState } from "react";

import { useMunicipality } from "@/context/MunicipalityContext";
import { useLegislationMonitorStates } from "@/hooks/legislationMonitor/useLegislationMonitorStates";

type ScopedValue<T> = {
  scopeKey: string;
  value: T;
};

function readScopedValue<T>(scoped: ScopedValue<T> | null, scopeKey: string): T | null {
  return scoped?.scopeKey === scopeKey ? scoped.value : null;
}

function normalizeMunicipalityState(state: string | null | undefined): string | null {
  return state?.trim().toUpperCase() || null;
}

export function useLegislationMonitorSelection() {
  const { municipality } = useMunicipality();
  const sessionStates = useLegislationMonitorStates();
  const municipalityState = normalizeMunicipalityState(municipality?.state);
  const selectedState =
    municipalityState && sessionStates.includes(municipalityState) ? municipalityState : null;
  const scopeKey = `${municipality?.id ?? "none"}:${selectedState ?? ""}`;

  const [lawSelection, setLawSelection] = useState<ScopedValue<number> | null>(null);
  const selectedLawId = readScopedValue(lawSelection, scopeKey);

  const setSelectedLawId = (lawId: number | null) => {
    setLawSelection(lawId == null ? null : { scopeKey, value: lawId });
  };

  return {
    municipality,
    sessionStates,
    selectedState,
    selectedLawId,
    setSelectedLawId,
  };
}
